import React, { useState } from 'react';
import Icon from '@mdi/react';
import { mdiViewList, mdiViewGridOutline } from '@mdi/js';
import {
  changeUiForShowingForms,
  getFormEditorControlData,
} from '../store/slices/formEditorSlice';
import { useDispatch, useSelector } from 'react-redux';

export const UiChangeViewButtons = () => {
  const controlData = useSelector(getFormEditorControlData);
  const dispatch = useDispatch();

  // local UI states per button (inline styles need this)
  const [hoverList, setHoverList] = useState(false);
  const [pressList, setPressList] = useState(false);
  const [focusList, setFocusList] = useState(false);

  const [hoverGrid, setHoverGrid] = useState(false);
  const [pressGrid, setPressGrid] = useState(false);
  const [focusGrid, setFocusGrid] = useState(false);

  const activate = (which) => {
    dispatch(changeUiForShowingForms());
  };

  // shared inline style builder
  const btnStyle = (active, hover, pressed, focus) => ({
    background: active ? '#c2c2c2ff' : '#ffffffff',
    border: 0,
    borderRadius: 8,
    padding: 8,
    cursor: 'pointer',
    transition: 'box-shadow 120ms ease, transform 80ms ease',
    outline: 'none',
    transform: pressed ? 'translateY(1px) scale(0.98)' : 'none',
    // subtle “inactive” edge, hover lift, and active/focus ring
    boxShadow:
      active || focus
        ? '0 0 0 2px rgba(76,122,241,0.6)'
        : hover
        ? '0 1px 2px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)'
        : 'inset 0 0 0 1px rgba(0,0,0,0.08)',
    // icon color via text color
    color: active ? '#111' : '#555',
  });

  return (
    <div style={{ display: 'flex', gap: 12, marginRight: 12 }}>
      {/* List view */}
      <button
        type="button"
        aria-label="List view"
        aria-pressed={controlData.uiForShowingForms === 'list'}
        title="List view"
        onClick={() => activate('list')}
        onMouseEnter={() => setHoverList(true)}
        onMouseLeave={() => {
          setHoverList(false);
          setPressList(false);
        }}
        onMouseDown={() => setPressList(true)}
        onMouseUp={() => setPressList(false)}
        onFocus={() => setFocusList(true)}
        onBlur={() => {
          setFocusList(false);
          setPressList(false);
        }}
        onKeyDown={(e) =>
          (e.key === ' ' || e.key === 'Enter') && setPressList(true)
        }
        onKeyUp={(e) =>
          (e.key === ' ' || e.key === 'Enter') && setPressList(false)
        }
        style={btnStyle(
          controlData.uiForShowingForms === 'list',
          hoverList,
          pressList,
          focusList
        )}
      >
        <Icon path={mdiViewList} size={1} />
      </button>

      <button
        type="button"
        aria-label="Grid view"
        aria-pressed={controlData.uiForShowingForms === 'grid'}
        title="Grid view"
        onClick={() => activate('grid')}
        onMouseEnter={() => setHoverGrid(true)}
        onMouseLeave={() => {
          setHoverGrid(false);
          setPressGrid(false);
        }}
        onMouseDown={() => setPressGrid(true)}
        onMouseUp={() => setPressGrid(false)}
        onFocus={() => setFocusGrid(true)}
        onBlur={() => {
          setFocusGrid(false);
          setPressGrid(false);
        }}
        onKeyDown={(e) =>
          (e.key === ' ' || e.key === 'Enter') && setPressGrid(true)
        }
        onKeyUp={(e) =>
          (e.key === ' ' || e.key === 'Enter') && setPressGrid(false)
        }
        style={btnStyle(
          controlData.uiForShowingForms === 'grid',
          hoverGrid,
          pressGrid,
          focusGrid
        )}
      >
        <Icon path={mdiViewGridOutline} size={1} />
      </button>
    </div>
  );
};
